import { maxLength } from 'ngrx-forms/validation';
import { BuildValidatorWithComparandDecorator } from './helpers';

export const MaxLength = BuildValidatorWithComparandDecorator<
  string,
  string,
  number
>(maxLength, 'DX.FORMS.VALIDATION.ERRORS.MAX_LENGTH');
